var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PenaltySummary = exports.PenaltyRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _FontelloIcon = _interopRequireDefault(require("../../../Basic/FontelloIcon"));

var _Basic = require("../../../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Header/Components/PenaltySummary.js";

var generatePenaltyRowKey = function generatePenaltyRowKey(index) {
  return "penaltyRow_" + index;
};

var PenaltyRow = function PenaltyRow(_ref) {
  var home = _ref.home,
      away = _ref.away;
  return _react.default.createElement(_Basic.Row, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Column, {
    flexing: true,
    alignRight: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 9
    }
  }, home && _react.default.createElement(_Basic.Row, {
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 17
    }
  }, _react.default.createElement(_Basic.Text, {
    fontSize: 13,
    alignRight: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 21
    }
  }, home.player.lastName), _react.default.createElement(_FontelloIcon.default, {
    name: home.failed ? 'missed-penalty' : 'GOAL',
    mx: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 21
    }
  }))), _react.default.createElement(_Basic.View, {
    center: true,
    isFlex: true,
    width: "30px",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, _react.default.createElement(_Basic.Text, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 13
    }
  }, ":")), _react.default.createElement(_Basic.Column, {
    flexing: true,
    alignLeft: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }, away && _react.default.createElement(_Basic.Row, {
    center: true,
    reverseRow: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 17
    }
  }, _react.default.createElement(_Basic.Text, {
    fontSize: 13,
    alignRight: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 21
    }
  }, away.player.lastName), _react.default.createElement(_FontelloIcon.default, {
    name: away.failed ? 'missed-penalty' : 'GOAL',
    mx: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 21
    }
  }))));
};

exports.PenaltyRow = PenaltyRow;

var PenaltySummary = function PenaltySummary(_ref2) {
  var penalties = _ref2.penalties;
  return _react.default.createElement(_Basic.Column, {
    mb: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }, penalties.reduceRight(function (result, item, index) {
    var returnResult = result;

    if (penalties.length % 2 === 0 && index % 2 === 0 || penalties.length % 2 !== 0 && index % 2 !== 0) {
      if (!item.away) {
        returnResult[0][0] = item;
      } else {
        returnResult[0][1] = item;
      }
    } else {
      if (!item.away) {
        returnResult.unshift([item, undefined]);
      } else {
        returnResult.unshift([undefined, item]);
      }
    }

    return returnResult;
  }, []).map(function (penalty, index) {
    return _react.default.createElement(PenaltyRow, {
      key: generatePenaltyRowKey(index),
      home: penalty[0],
      away: penalty[1],
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 17
      }
    });
  }));
};

exports.PenaltySummary = PenaltySummary;